// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var MM_api = require("./MM_api.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Raw_js_utils = require("../utils/Raw_js_utils.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_cmp_multiline_text_input = require("./MM_cmp_multiline_text_input.res.js");
var PriorityHigh = require("@mui/icons-material/PriorityHigh").default;

function initUiApi(modalRef) {
  MM_api.setUiApi(MM_api.makeApiFunc("showInfoMsg", (function (__x) {
              var params = MM_api.apiInputToObjExn(__x, "apiShowInfoMsg: got empty parameters.");
              var msg = Raw_js_utils.reqStrExn(params.msg, "'msg' must be a string.");
              return new Promise((function (resolve, param) {
                            MM_react_common.openInfoDialog(modalRef, undefined, undefined, Caml_option.some(React.createElement("pre", undefined, msg)), undefined, (function () {
                                    resolve({
                                          TAG: "Ok",
                                          _0: undefined
                                        });
                                  }), undefined, undefined, undefined);
                          }));
            })), MM_api.makeApiFunc("showErrMsg", (function (__x) {
              var params = MM_api.apiInputToObjExn(__x, "apiShowErrMsg: got empty parameters.");
              var msg = Raw_js_utils.reqStrExn(params.msg, "'msg' must be a string.");
              return new Promise((function (resolve, param) {
                            MM_react_common.openInfoDialog(modalRef, undefined, Caml_option.some(React.createElement("span", {
                                          style: {
                                            color: "red"
                                          }
                                        }, React.createElement(PriorityHigh, {}))), Caml_option.some(React.createElement("pre", undefined, msg)), undefined, (function () {
                                    resolve({
                                          TAG: "Ok",
                                          _0: undefined
                                        });
                                  }), undefined, undefined, undefined);
                          }));
            })), MM_api.makeApiFunc("multilineTextInput", (function (__x) {
              var params = MM_api.apiInputToObjExn(__x, "apiMultilineTextInput: got empty parameters.");
              var prompt = Raw_js_utils.optStrExn(params.prompt, "'prompt' must be a string.");
              var initText = Raw_js_utils.optStrExn(params.initText, "'initText' must be a string.");
              return new Promise((function (resolve, param) {
                            MM_react_common.openModalPaneWithTitle(modalRef, prompt, (function (close) {
                                    return React.createElement(MM_cmp_multiline_text_input.make, {
                                                initText: initText,
                                                onOk: (function (text) {
                                                    close();
                                                    resolve({
                                                          TAG: "Ok",
                                                          _0: Object.fromEntries([
                                                                [
                                                                  "text",
                                                                  text
                                                                ],
                                                                [
                                                                  "okClicked",
                                                                  true
                                                                ]
                                                              ])
                                                        });
                                                  }),
                                                onCancel: (function () {
                                                    close();
                                                    resolve({
                                                          TAG: "Ok",
                                                          _0: Object.fromEntries([[
                                                                  "okClicked",
                                                                  false
                                                                ]])
                                                        });
                                                  })
                                              });
                                  }));
                          }));
            })));
}

exports.initUiApi = initUiApi;
/* react Not a pure module */
